type CoursesDateFormat = (dateString: string) => string

const coursesDateFormat: CoursesDateFormat = (dateString) => {
  if (dateString) {
    const date = new Date(dateString)

    return date.toLocaleString('en-US', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    })
  }
  return ''
}

export { coursesDateFormat }
